import React from 'react';
import { motion } from 'framer-motion';
import { XIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { CtaButton } from './CtaButton';
import { pains } from '../data/content';
export function PainSection() {
  return <section className="w-full bg-ink-900 py-20" aria-labelledby="pain-title" data-id="element-163" data-mp="2v08bdgmfgl1o">
      <div className="mx-auto max-w-6xl px-5" data-id="element-164" data-mp="2yy60kjg77752">
        <SectionHeading eyebrow="El ciclo que se repite" title={<span id="pain-title" data-id="element-166" data-mp="2l6j6mq9qaapg">
              ¿Cuántas mañanas más vas a despertar <span className="text-rose-400" data-id="element-167" data-mp="2q0dk3byqptg3">sintiéndote así?</span>
            </span>} subtitle={<>
              Querés un cambio real, pero terminás los días agotada, inflamada y eligiendo ropa suelta
              para esconder lo que no te gusta.{' '}
              <span className="font-semibold text-cream" data-id="element-168" data-mp="22a01sd5yj8yp">
                No es falta de voluntad. Es falta de un sistema.
              </span>
            </>} data-id="element-165" data-mp="2l8m41vd7n647" />

        <ul className="mt-14 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-169" data-mp="3rlzk5jqrwdr1">
          {pains.map((p, i) => <motion.li key={p.title} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.4,
          delay: Math.min(i * 0.05, 0.3),
          ease: 'easeOut'
        }} className="flex gap-4 rounded-2xl border border-rose-600/20 bg-ink-800/70 p-5" data-id="element-170" data-mp="3nknpv0wyf4ci" data-mpi={i}>
              <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-rose-600/20" data-id="element-171" data-mp="33z14upee3bup">
                <XIcon className="h-4 w-4 text-rose-400" aria-hidden="true" data-id="element-172" data-mp="3innjsq03u1le" />
              </span>
              <div data-id="element-173" data-mp="3dub5p9t1xd6w">
                <h3 className="font-semibold text-cream" data-id="element-174" data-mp="3dtszplgl7kls">{p.title}</h3>
                <p className="mt-1 text-sm leading-relaxed text-cream/65" data-id="element-175" data-mp="2q4gvl004a2qc">{p.text}</p>
              </div>
            </motion.li>)}
        </ul>

        <div className="mt-14 flex flex-col items-center gap-6 rounded-3xl border border-gold-500/25 bg-ink-800/60 px-6 py-10 text-center" data-id="element-176" data-mp="p4byvbnzenq9">
          <p className="font-display text-2xl uppercase leading-tight text-cream sm:text-3xl" data-id="element-177" data-mp="u1c3rj93hkfs">
            ¿Y si este fuera el último lunes que empezás de cero?
          </p>
          <div className="w-full max-w-sm" data-id="element-178" data-mp="12vgtu0gemru9">
            <CtaButton href="#comprar" data-id="element-179" data-mp="12xbav3ok1zt2">Quiero romper el ciclo ahora</CtaButton>
          </div>
        </div>
      </div>
    </section>;
}